













 
import settings from '@/settings.coffee'
import ImageUploader from '@/components/ImageUploader.vue'
import ImageListUploader from '@/components/ImageListUploader.vue'
import mutations from '@/gql/mutations.coffee'

export default {
    "name": "Establishmentpictures"
    "components":{ImageUploader, ImageListUploader}
    "props": {
        "establishment": Object
    }
    "data":()->
        {}
    "computed":{
        "active": ()->
            return this.establishment.uid?
        "icon_info":()->
            self = this
            url = null
            uid = null
            if self.establishment?
                if self.establishment.logo not in [""]
                    url = settings.backendMediaUrl + self.establishment.logo
                uid = self.establishment.uid
            {
                "label": "Icône"
                "url": url
                "upload_call_back":(img_data, img_name)->
                    return mutations.run("establishment_update_logo",
                                 [uid, img_data, img_name])
                "delete_callback": ()->
                    return mutations.run("establishment_update_logo",
                                 [uid, null, null])
            }
            
        "main_picture_info": ()->
            self = this
            url = null
            uid = null
            if self.establishment?
                if self.establishment.main_picture not in [""]
                    url = settings.backendMediaUrl + self.establishment.main_picture
                uid = self.establishment.uid
            {
                "label": "Fond"
                "url": url
                "upload_call_back":(img_data, img_name)->
                    return mutations.run("establishment_update_main_picture",
                                 [uid, img_data, img_name])
                "delete_callback": ()->
                    return mutations.run("establishment_update_main_picture",
                                 [uid, null, null])
            }
        "picture_list_info": ()->
            self = this
            ret = []
            if self.establishment? and self.establishment.image_set?
                for img in self.establishment.image_set

                    ret.push({
                        "label": ""
                        "url": settings.backendMediaUrl + img.picture
                        "upload_call_back":(img_data, img_name)->
                            return mutations.run("establishment_update_picture",
                                [img.uid, self.establishment.uid ,img_data, img_name])
                        "delete_callback": ()->
                            return mutations.run("establishment_update_picture",
                                 [img.uid, self.establishment.uid, null, null])
                    })
                ret.push({
                    "label":""
                    "url":null
                    "upload_call_back":(img_data, img_name)->
                         return mutations.run("establishment_update_picture",
                            [null, self.establishment.uid, img_data, img_name])
                })
            return ret
        
    }
}
